import './form-referral-setting.scss';

import { ReferralTypeEnum } from '@core/model/local-referral-settings';
import { ReferralSettingFormSchema } from "@factory/form/form.rule";
import { LabelValue } from '@shared/models/label-value.interface';
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from '@shared/ui/hook-form/dropdown-control/dropdown-control';
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = ReferralSettingFormSchema;
export function FormReferralSetting() {
  const { control } = useFormContext<ReferralSettingFormSchema>();
  const referralTypes: LabelValue[] = [
    {
      label: "Initial Registration Reward",
      value: ReferralTypeEnum.Initial
    },
    // {
    //   label: "Milestones ()",
    //   value: ReferralTypeEnum.Milestone,
    // }
  ]
  return (
    <div id="FormReferralSetting" className="referral-setting">
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label="Points"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter points"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamp"
        label="Stamp"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter stamp"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="referralType"
        label="Referral Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter referralType"
        options={referralTypes}
      />
    </div>
  );
}

export default FormReferralSetting;
